"use strict";
(self["webpackChunk"] = self["webpackChunk"] || []).push([[3570],{

/***/ 63570:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var _images_pattern_svg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85492);
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78265);
/* harmony import */ var _index_erb__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_erb__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99127);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83371);
/* harmony import */ var _index_rb__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_index_rb__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_event_manager__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69705);





class QuestionCounter {
    get limitAnswer() {
        const { answerLimit } = window.currentUser;
        return Number(answerLimit);
    }
    get progressSize() {
        return this.sizeStrokeDash * (1 - this.answeredCount / this.limitAnswer);
    }
    get hasReachedCheckpoint() {
        return this.stepsAnswered.includes(this.answeredCount);
    }
    setStrokeProgress() {
        this.$progress.attr('stroke-dasharray', this.sizeStrokeDash).attr('stroke-dashoffset', this.progressSize);
    }
    setText() {
        const defaultData = this.$questionCounter.data('default-content');
        const emphasizedData = this.$questionCounter.data('emphasized-content');
        const text = this.answeredCount >= 7 ? emphasizedData : defaultData;
        this.$questionCounter.find('[data-title]').html(text.title);
        this.$questionCounter.find('[data-subtitle]').html(text.subtitle);
        this.$questionCounter.find('[data-button]').html(text.cta_text);
        this.setCtaInteractions(text.cta_link);
    }
    setCtaInteractions(ctaLink) {
        const cta = this.$questionCounter.find('[data-button]');
        if (!ctaLink) {
            return cta.on('click', (e)=>this.closeModal(e));
        }
        cta.attr('href', ctaLink);
    }
    updateCounter(remaining) {
        this.setText();
        this.setStrokeProgress();
        const counterText = `${remaining} de ${this.limitAnswer}`;
        this.$questionCounter.find('[data-remaining]').html(counterText);
        this.$questionCounter.find('[data-available]').html(remaining);
        Number(remaining) === 0 && this.$questionCounter.hide();
    }
    handleQuestionsAnswer(data) {
        const resolvedToday = data.resolvedQuestions;
        const answeredCount = resolvedToday + 1;
        const remaining = this.limitAnswer - answeredCount;
        this.answeredCount = answeredCount;
        const hasQuestionsRemaining = resolvedToday <= this.limitAnswer;
        const allowedToShowModal = this.hasReachedCheckpoint && hasQuestionsRemaining;
        this.updateCounter(remaining);
        if (allowedToShowModal) {
            this.openModal();
        }
    }
    skipFirstStep() {
        this.stepsAnswered.shift();
    }
    openModal() {
        this.$questionCounter.addClass('open').show();
    }
    closeModal(e) {
        e.preventDefault();
        this.$questionCounter.hide();
    }
    bind() {
        utils_event_manager__WEBPACK_IMPORTED_MODULE_4__/* .EventManager.subscribe */ .Q.subscribe('question.answer', (msg, data)=>this.handleQuestionsAnswer(data));
        utils_event_manager__WEBPACK_IMPORTED_MODULE_4__/* .EventManager.subscribe */ .Q.subscribe('checkinModal.open', ()=>this.skipFirstStep());
        this.$questionCounter.find('.close-button').on('click', (e)=>this.closeModal(e));
    }
    constructor(){
        this.$questionCounter = window.jQuery('#question-counter');
        if (!this.$questionCounter.length) {
            return;
        }
        this.answeredCount = 0;
        this.stepsAnswered = [
            1,
            7
        ];
        this.$progress = this.$questionCounter.find('.circle-front');
        this.radiusProgress = Number(this.$progress.attr('r'));
        this.sizeStrokeDash = 2 * Math.PI * this.radiusProgress + 1;
        this.bind();
    }
}
new QuestionCounter();


/***/ })

}]);